<template>
    <div class="d-flex flex-row flex-nowrap">
        <div class="flex-grow-1">

            <v-text-field
                ref="passwordField"
                :label="label"
                :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (passwordVisible = !passwordVisible)"
                :type="passwordVisible ? 'text' : 'password'"
                v-model="password"
                required
                :errorMessages="passwordErrorMessages"
                :counter="60"
                prepend-icon="mdi-lock"
                :disabled="disabled"
                @input="passwordInput"
                tabindex="1"
                autocomplete="off"
                :dark="isDarkColor(backgroundColor)"
                :solo="solo"
            ></v-text-field>

            <v-text-field
                :label="labelConfirm"
                :append-icon="passwordConfirmationVisible ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (passwordConfirmationVisible = !passwordConfirmationVisible)"
                :type="passwordConfirmationVisible ? 'text' : 'password'"
                v-model="passwordConfirmation"
                required
                :errorMessages="confirmationErrorMessages"
                :counter="60"
                prepend-icon="mdi-lock"
                :disabled="disabled"
                @input="confirmationInput"
                @keydown.enter="enterPressed"
                tabindex="2"
                autocomplete="off"
                :dark="isDarkColor(backgroundColor)"
                :solo="solo"
            ></v-text-field>
        </div>

        <div class="ml-8 mr-2 mt-2 d-none flex-shrink-1 d-sm-flex">

            <div class="text-center">

                <v-progress-circular :value="securityIndex"
                                     size="90"
                                     width="10"
                                     tabindex="-1"
                                     :color="securityColor"
                                     :dark="isDarkColor(backgroundColor)"
                >
                    {{ securityIndex }}
                </v-progress-circular>

                <div :class="'pt-2 caption ' + getFontClasses(backgroundColor) " :color="securityColor">
                    {{ labelSecurityIndicator }}
                </div>

            </div>


        </div>

    </div>
</template>

<script>

import colorMixin from "./DynamicProflingQuestions/colorMixin";

export default {

    mixins: [colorMixin],

    props: {
        value: {
            required: false,
            type: String,
            default: '',
        },
        // errorMessages: {
        //     required: false,
        //     type: Array,
        // },
        label: {
            required: false,
            type: String,
            default: 'Password'
        },
        labelConfirm: {
            required: true,
            type: String,
        },
        labelSecurityIndicator: {
            required: false,
            type: String,
            default: 'Password security'
        },
        validationRequiredError: {
            required: false,
            type: String,
            default: 'Password field is required'
        },
        validationComplexityError: {
            required: false,
            type: String,
            default: 'Password must be 7 or more characters and must contain at ' +
                'least one number, upper case character and special character'
        },
        validationMismatchError: {
            required: false,
            type: String,
            default: 'Passwords do not match'
        },
        autoFocus: {
            required: false,
            type: Boolean,
            default: false,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            required: false,
            type: String,
            default: "#FFFFFF"
        },
        solo: {
            required: false,
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            password: '',
            passwordConfirmation: '',
            securityIndex: 0,
            securityColor: 'red',
            passwordVisible: false,
            passwordConfirmationVisible: false,
            isPasswordMatching: false,
            isPasswordSecure: false,
            passwordErrorMessages:[],
            confirmationErrorMessages:[]
        }
    },

    watch: {
        value(newValue) {
            if (this.password === '') this.populateFields(newValue);
        }
    },

    mounted() {
        if (this.value !== null) {
            this.populateFields(this.value);
        }

        if (this.autoFocus) {
            this.$nextTick(() => this.$refs.passwordField.focus());
        }
    },

    computed: {

        // This method is for Vuetify form validation
        valid() {
            return this.isPasswordSecure && this.isPasswordMatching;
        },

        hasError() {
            return !!this.errorMessage;
        },
    },

    methods: {

        populateFields(value) {
            this.password = value;
            this.passwordConfirmation = value;
        },

        passwordInput(input) {

            this.passwordErrorMessages = [];

            if (input.length >= 7) {

                if (!this.checkComplexity(input)) {
                    this.passwordErrorMessages = [this.validationComplexityError];
                }
            }

            this.inputEvent();
        },

        confirmationInput(value) {

            this.confirmationErrorMessages = [];

            if (value.length >= 7 && !this.checkMatch()) {
                this.confirmationErrorMessages = [this.validationMismatchError];
            }

            this.inputEvent();
        },

        // Check if form password and verification match
        checkMatch() {
            if (this.password === this.passwordConfirmation) {
                this.isPasswordMatching = true;
                return true;
            }
            this.isPasswordMatching = false;
            return false;
        },

        // Check password complexity
        checkComplexity(input) {

            //this.checkMatch();

            const strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
            const mediumRegex = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
            const enoughRegex = new RegExp("(?=.{7,}).*", "g");

            if (strongRegex.test(input)) {
                this.securityColor = 'success';
                this.securityIndex = 100;
                this.isPasswordSecure = true;
                return true;
            } else if (mediumRegex.test(input)) {
                this.securityColor = 'warning'
                this.securityIndex = 65;
            } else if (enoughRegex.test(input)) {
                this.securityColor = 'error';
                if (input.length > 4) this.securityIndex = 75;
            } else {
                this.securityIndex = 0;
            }

            this.isPasswordSecure = false;

            return this.isPasswordSecure;
        },

        inputEvent() {

            this.$emit('input', this.password);
            this.$emit('valid', this.valid)
        },

        enterPressed() {
            if (this.valid) {
                this.$emit('enter');
            }
        }
    }
}
</script>
